import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
} from '@mui/material';
import './styles.scss';
import { Employee } from '../../types/employee';


interface SelectEmployeeDialogProps {
    open: boolean;
    title?: string;
    onCancel: () => void;
    onSubmit: (emp: Employee) => void; // new prop
    employees?: Employee[];
}

export const SelectEmployeeDialog = ({
    open,
    title = "Find your name",
    onCancel,
    onSubmit,
    employees = [],
}: SelectEmployeeDialogProps) => {
    return (
        <Dialog open={open} onClose={onCancel} fullWidth maxWidth="sm" className="select-employee-dialog">
            <DialogTitle>{title}<span>Choose your name to open the time clock.</span></DialogTitle>
            <DialogContent className="dialog-content-employee">
                <div className="employee-list">
                    {employees.length > 0 ? (
                        employees.map(emp => (
                            <button
                                key={emp.id}
                                className="employee-pill"
                                onClick={() => onSubmit(emp)}
                            >
                                <span className="employee-list-avatar" aria-hidden="true">{emp.firstName.charAt(0)}{emp.lastName.charAt(0)}</span>
                                <span>{emp.firstName} {emp.lastName}</span>
                                <span aria-hidden="true">›</span>
                            </button>
                        ))
                    ) : (
                        <p>No employees to show.</p>
                    )}
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} className="cancel-button">
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};
